(ns shared.core.components.fonts.data
  (:require-macros [cljs.core.async.macros :refer [go]])
  (:require [shared.core.reactive :as re]
            [shared.core.config :as config]
            [cljs.core.async :refer [<!]]
            [cljs-http.client :as http]
            [clojure.string :as s]))

(def root-path [:fonts])
(def fonts-list-path (conj root-path :list))
(def fonts-imported-path (conj root-path :imported))

(defn fonts-list [db] (get-in db fonts-list-path))
(defn fonts-imported [db] (get-in db fonts-imported-path))

(defn build-import-url [{:keys [font-family variants]}]
  (when-not (s/blank? font-family)
    (str "https://fonts.googleapis.com/css2?family=" font-family
         (when-not (empty? variants)
           (str ":wght@" (s/join ";" (sort variants))))
         "&display=swap")))

(re/reg-event-db
  :fonts/set-list re/middleware
  (fn [db [list-data]]
    (assoc-in db fonts-list-path list-data)))

(re/reg-event-db
  :fonts/load-list re/middleware
  (fn [db]
    (go (let [resp (->> (<! (http/get (str "https://www.googleapis.com/webfonts/v1/webfonts?key=" config/GOOGLE_MAPS_API_KEY)
                                      {:with-credentials? false}))
                        :body :items (flatten))]
          (re/dispatch [:fonts/set-list resp])))
    db))

(re/reg-event-db
  :fonts/import re/middleware
  (fn [db [font-url]]
    (let [imported-fonts (fonts-imported db)
          head-el (.-head js/document)
          links-contains-href? (fn [url] (some #(= (str (.-href %)) url) (.getElementsByTagName head-el "link")))
          add-link (fn [{:keys [href rel cross-origin?]}]
                     (let [el (.createElement js/document "link")]
                       (set! (.-rel el) rel)
                       (set! (.-href el) href)
                       (when cross-origin?
                         (.setAttribute el "crossorigin" ""))
                       (.appendChild head-el el)
                       el))]
      (when-not (links-contains-href? "https://fonts.googleapis.com/")
        (add-link {:href "https://fonts.googleapis.com/"
                   :rel "preconnect"}))
      (when-not (links-contains-href? "https://fonts.gstatic.com/")
        (add-link {:href "https://fonts.gstatic.com/"
                   :rel "preconnect"
                   :cross-origin? true}))
      (cond
        (s/blank? font-url) db

        (some #(= % font-url) imported-fonts) db

        :else
        (do (add-link {:href font-url
                       :rel "stylesheet"})
            (assoc-in db fonts-imported-path (conj (or imported-fonts []) font-url)))))))

(re/reg-sub
  :fonts/list-
  (fn [db]
    (let [current-list (fonts-list db)]
      (if current-list
        current-list
        (do
          (re/dispatch [:fonts/load-list])
          :loading)))))
